export default "__VITE_ASSET__C40QW1wU__"